export enum SubjectType {
	Person = 'person',
	Product = 'product',
	Text = 'text',
	Logo = 'logo',
	Scene = 'scene',
	Other = 'other'
}

export interface BoundingBox {
	x: number;
	y: number;
	width: number;
	height: number;
}

export interface FocalArea {
	name: string;
	subjectType: SubjectType;
	areaType?: string; // Primary Subject, Background, etc.
	cropMode?: 'cover' | 'contain'; // How the crop should be applied
	aspectPriority?: 'crop' | 'target'; // How to prioritize aspect ratio vs. target area (default: 'target')
	boundingBox: BoundingBox;
	aspectRatio: string;
	targetWidth?: number;
	targetHeight?: number;
	isDefault?: boolean;
	tags?: string[];
}

export interface AssetMetadata {
	targetCrops?: FocalArea[];
}
